import { createContext, useContext, useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { API_URL } from "./constants";

const UserDetailsContext = createContext(null);

export const UserDetailsProvider = ({ children }) => {
    const [userDetails, setUserDetails] = useState();
    // const [userDetails, setUserDetails] = useState(() => {
    //     // Load userDetails from localStorage on initial render
    //     const storedDetails = localStorage.getItem("userDetails");
    //     return storedDetails ? JSON.parse(storedDetails) : null;
    // });

    const [token, setToken] = useState(null);

    // Update localStorage whenever userDetails changes
    // useEffect(() => {
    //     if (userDetails) {
    //         localStorage.setItem("userDetails", JSON.stringify(userDetails));
    //     } else {
    //         localStorage.removeItem("userDetails");
    //     }
    // }, [userDetails]);

    // Listen for Firebase authentication changes and update the token & details
    useEffect(() => {
        const auth = getAuth();
        return onAuthStateChanged(auth, async (firebaseUser) => {
            if (firebaseUser) {
                const idToken = await firebaseUser.getIdToken();
                setToken(idToken);

                // Fetch user details from backend to ensure we have plan info
                try {
                    const formData = new FormData();
                    formData.append('user_id', firebaseUser.uid);
                    formData.append('display_name', firebaseUser.displayName || "User");
                    formData.append('email', firebaseUser.email || "");
                    formData.append('phone_number', firebaseUser.phoneNumber || "");
                    formData.append('photo_url', firebaseUser.photoURL || "");
                    formData.append('account_creation_time', firebaseUser.metadata.creationTime || "");
                    formData.append('last_login_time', firebaseUser.metadata.lastSignInTime || "");

                    // Attach referral code if present (captured from ?ref= URL param at sign-in)
                    const referralCode = sessionStorage.getItem('referral_code');
                    if (referralCode) {
                        formData.append('referral_code', referralCode);
                        sessionStorage.removeItem('referral_code'); // Only send once
                    }

                    const response = await fetch(`${API_URL}/api/manage-user`, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${idToken}`
                        },
                        body: formData
                    });

                    if (response.status === 400 && referralCode) {
                        // Invalid referral code — delete the Firebase user entirely and reject sign-in
                        try {
                            await firebaseUser.delete();
                        } catch (deleteError) {
                            console.error("Error deleting user after invalid referral code:", deleteError);
                        }
                        sessionStorage.setItem(
                            'auth_error',
                            'The referral code you used is not valid. Please use a valid referral link or contact support.'
                        );
                        window.location.href = '/signin';
                        return;
                    }

                    if (response.ok) {
                        const data = await response.json();
                        if (data.user_details) {
                            setUserDetails(data.user_details);
                        }
                    }
                } catch (error) {
                    console.error("Error fetching user details:", error);
                }

            } else {
                setToken(null);
                setUserDetails(null);
            }
        });
    }, []);

    return (
        <UserDetailsContext.Provider value={{ userDetails, setUserDetails, token }}>
            {children}
        </UserDetailsContext.Provider>
    );
};

export const useUserDetails = () => {
    const context = useContext(UserDetailsContext);
    if (!context) {
        throw new Error("useUserDetails must be used within a UserDetailsProvider");
    }
    return context;
};